var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M0 0h87.196v365H0zm170.81 0h87.196v365h-87.197z"}));
}

Pause.defaultProps = {"xmlSpace":"preserve","viewBox":"0 0 258.006 365"};

module.exports = Pause;

Pause.default = Pause;
